const INTERCOM_HIDE_STYLE_ID = 'intercom-hide-style'
const INTERCOM_ELEVATE_STYLE_ID = 'intercom-elevate-style'

/** Au-dessus des footers onboarding / CRA (z-21474830002) et modales associées. */
export const INTERCOM_MESSENGER_Z_INDEX = 21474830110

let intercomHelpOpen = false

export function setIntercomHelpOpen(open: boolean): void {
  intercomHelpOpen = open
}

export function isIntercomHelpOpen(): boolean {
  return intercomHelpOpen
}

const INTERCOM_Z_INDEX_SELECTORS = `
  .intercom-lightweight-app,
  .intercom-lightweight-app-launcher,
  .intercom-messenger-frame,
  #intercom-container,
  .intercom-app,
  iframe[name="intercom-messenger-frame"],
  iframe[title*="Intercom"],
  div[id*="intercom-frame"],
  div[class*="intercom-with-namespace"] {
    z-index: ${INTERCOM_MESSENGER_Z_INDEX} !important;
  }
`

export function applyIntercomHideStyle(): void {
  if (intercomHelpOpen || document.getElementById(INTERCOM_HIDE_STYLE_ID) || !document.head) {
    return
  }

  const style = document.createElement('style')
  style.id = INTERCOM_HIDE_STYLE_ID
  style.textContent = `
    [data-intercom-target],
    .intercom-lightweight-app,
    #intercom-container,
    iframe[title*="Intercom"],
    div[id*="intercom"],
    div[class*="intercom"],
    [id*="intercom"],
    [class*="intercom"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  `
  document.head.appendChild(style)
}

export function removeIntercomHideStyle(): void {
  document.getElementById(INTERCOM_HIDE_STYLE_ID)?.remove()
}

export function applyIntercomElevatedZIndexStyle(): void {
  if (document.getElementById(INTERCOM_ELEVATE_STYLE_ID) || !document.head) {
    return
  }

  const style = document.createElement('style')
  style.id = INTERCOM_ELEVATE_STYLE_ID
  style.textContent = INTERCOM_Z_INDEX_SELECTORS
  document.head.appendChild(style)
}

export function removeIntercomElevatedZIndexStyle(): void {
  document.getElementById(INTERCOM_ELEVATE_STYLE_ID)?.remove()
}

export function openIntercomHelpSurface(): void {
  setIntercomHelpOpen(true)
  removeIntercomHideStyle()
  applyIntercomElevatedZIndexStyle()
}

export function closeIntercomHelpSurface(rehide = true): void {
  setIntercomHelpOpen(false)
  removeIntercomElevatedZIndexStyle()
  if (rehide) {
    applyIntercomHideStyle()
  }
}

declare global {
  interface Window {
    Intercom?: (...args: unknown[]) => void
  }
}

export function registerIntercomHelpHideListener(onHiddenRoute: boolean): void {
  if (!onHiddenRoute || typeof window.Intercom !== 'function') {
    return
  }

  window.Intercom('onHide', () => {
    closeIntercomHelpSurface(true)
  })
}
